import React, { Fragment, useCallback, useEffect, useMemo } from "react";
import Button from "../Button/Button";
import axios from "axios";
import { baseURL } from "../../constants/pathnames";
import { useSelector } from "react-redux";

const ModalUserDeactive = ({ onCancel, getdata, id, is_active }) => {
  const { token } = useSelector((state) => state.users);
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);

  // const [loader, setLoader] = useState(false);

  useEffect(() => {
    const overlay = document.querySelector(".modal-overlay");
    const listener = (event) => {
      if (overlay) {
        onCancel();
        console.log(event);
      }
    };
    overlay.addEventListener("click", listener);
  });

  const handleDeactive = useCallback(() => {
    const patchdata = { is_active: !is_active };
    axios
      .patch(`${baseURL}auth/panel/update/${id}/`, patchdata, header)
      .then((res) => {
        // setLoader(false);
        // history.goBack();
        getdata();
        onCancel();
      })
      .catch((err) => {
        // setLoader(false);
        console.log(err);
      });
  }, [header, id, is_active, onCancel, getdata]);

  return (
    <Fragment>
      <div
        style={{ zIndex: "1000000" }}
        className='fixed inset-0 overflow-y-auto '
        aria-labelledby='modal-title'
        role='dialog'
        aria-modal='true'
      >
        <div
          className='flex items-center  min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 transition-opacity ease-in duration-300'
          // transition-opacity ease-in duration-300
          style={{ transition: "opacity 0.25s ease" }}
        >
          <div
            className='fixed inset-0 bg-gray-500 bg-opacity-50  modal-overlay'
            aria-hidden='true'
            // ref={ref}
          ></div>

          <span
            className='hidden sm:inline-block sm:align-middle sm:h-screen'
            aria-hidden='true'
          >
            &#8203;
          </span>

          <div className='inline-block bg-white rounded-2xl overflow-hidden shadow-xl transform transition-all sm:my-8 align-middle sm:max-w-2xl w-full'>
            <div className='bg-white py-9'>
              <div className='max-w-xl mx-auto w-full'>
                <>
                  <div className='color-red  font-bold text-lg'>
                    آیا از {is_active ? "غیرفعال" : "فعال"} کردن این کاربر مطمئن
                    هستید؟
                  </div>
                  <img
                    className='mx-auto my-10'
                    src='/statics/images/failure.svg'
                    // width='34px'
                    alt='arrow'
                  />
                  <div className='flex justify-center items-center gap-4'>
                    <Button
                      title='بله'
                      margin='0'
                      backgroundColor='#cf4e4e'
                      maxWidth='150px'
                      maxHeight='40px'
                      onClick={() => {
                        handleDeactive();
                      }}
                    />
                    <Button
                      title='خیر'
                      backgroundColor='#fff'
                      borderColor='#cf4e4e'
                      color='#cf4e4e'
                      borderWidth='2px'
                      margin='0'
                      maxHeight='40px'
                      maxWidth='150px'
                      onClick={() => {
                        onCancel();
                      }}
                    />
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ModalUserDeactive;
